import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { useEffect, useMemo, useState } from 'react';
import { ApplicationState, WithAvailabilityBlockId } from '@mews-commander/types';
import { Stack } from '@optimus-web/core';
import { AsyncMetaState } from '@mews/framework';
import { withAsyncContainer } from '@mews-commander/ui';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { isInitFetching, hasInitFailed } from '../selectors';
import { destroyAvailabilityBlockScope } from '../actions/availabilityBlock';
import { useAvailabilityBlock } from '../utils/useAvailabilityBlock';
import { BlockSetup } from './BlockSetup/BlockSetup';
import { Header } from './Header/Header';
import {
    OverrideReleaseDialogData,
    OverrideAvailabilityReleaseDialog,
    OverrideReleaseDialogContext,
} from './OverrideAvailabilityReleaseDialog';

type AvailabilityBlockProps = WithAvailabilityBlockId;

const AvailabilityBlock: React.FC<AvailabilityBlockProps> = ({ availabilityBlockId }) => {
    const dispatch = useCommanderThunkDispatch();

    const availabilityBlock = useAvailabilityBlock(availabilityBlockId);

    const [overrideDialogData, setOverrideDialogData] = useState<OverrideReleaseDialogData | null>(null);
    const closeOverrideDialog = () => setOverrideDialogData(null);
    const dialogContextValue = useMemo(
        () => ({ openOverrideDialog: (data: OverrideReleaseDialogData) => setOverrideDialogData(data) }),
        []
    );

    useEffect(
        () => () => {
            dispatch(destroyAvailabilityBlockScope());
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    if (!availabilityBlock) {
        return null;
    }

    const { serviceId } = availabilityBlock;

    return (
        <>
            <OverrideReleaseDialogContext.Provider value={dialogContextValue}>
                <Stack vertical spacing="300">
                    <Header availabilityBlockId={availabilityBlockId} />

                    <BlockSetup availabilityBlockId={availabilityBlockId} serviceId={serviceId} />
                </Stack>
            </OverrideReleaseDialogContext.Provider>

            <OverrideAvailabilityReleaseDialog
                availabilityBlock={availabilityBlock}
                closeDialog={closeOverrideDialog}
                data={overrideDialogData}
            />
        </>
    );
};

export default compose(
    connect<AsyncMetaState, {}, {}, ApplicationState>(
        createStructuredSelector({
            isFetching: isInitFetching,
            hasFailed: hasInitFailed,
        })
    ),
    withAsyncContainer
)(AvailabilityBlock) as React.FC<AvailabilityBlockProps>;
